import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { toast } from 'react-toastify'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ProjectsApiService } from 'src/services/projectsApi'
import {
  ProjectErrorResponse,
  ProjectPayload,
} from 'src/services/projectsApi/interfaces/projects.interface'

interface UpdateProjectMutationArgs {
  id: string
  payload: ProjectPayload
}

interface UseUpdateProjectMutationParams {
  onSuccess?: () => void
}

const updateProject = async ({ id, payload }: UpdateProjectMutationArgs) =>
  ProjectsApiService.update(id, payload)

export const useUpdateProjectMutation = ({
  onSuccess,
}: UseUpdateProjectMutationParams = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateProject,
    onError: (error: AxiosError<ProjectErrorResponse>) => {
      toast.error(
        error.response?.data?.errors?.join(', ') ||
          error.response?.data?.error ||
          'Failed to update project'
      )
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.GET_PROJECTS] })
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_PROJECT, variables.id],
      })
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_PROJECT_DASHBOARD, variables.id],
      })
      toast.success('Project updated successfully')
      onSuccess?.()
    },
  })
}
